import type { TOC } from '@ember/component/template-only';
import { fn } from '@ember/helper';
import { on } from '@ember/modifier';
import ExceptionIndicator from 'lumen/components/hotel/pricing-assistant/exception-indicator';
import OverrideIndicator from 'lumen/components/hotel/pricing-assistant/override-indicator';
import type {
  DayOverrideModalTabIds,
  OverrideVariant,
} from 'lumen/utils/constants/pricing-assistant-constants';

import styles from './sidebar.module.css';

export interface SidebarItem {
  hasException?: boolean;
  hasOverride?: boolean;
  id: DayOverrideModalTabIds;
  label: string;
  overrideVariant?: OverrideVariant;
}

interface DayOverrideModalSidebarSignature {
  Args: {
    activeTabId: DayOverrideModalTabIds;
    ariaLabel?: string;
    items: SidebarItem[];
    onSelect: (id: DayOverrideModalTabIds) => void;
  };
}

const isActive = (activeTabId: string, id: string): boolean =>
  activeTabId === id;

const DayOverrideModalSidebar = <template>
  <nav aria-label={{@ariaLabel}} class={{styles.sidebar}}>
    <ul class={{styles.list}}>
      {{#each @items as |item|}}
        <li>
          <button
            aria-current={{if (isActive @activeTabId item.id) "page"}}
            class="{{styles.item}}
              {{if (isActive @activeTabId item.id) styles.active}}"
            data-test-id="day-override-modal-sidebar-{{item.id}}"
            type="button"
            {{on "click" (fn @onSelect item.id)}}
          >
            {{item.label}}
            {{#if item.hasException}}
              <ExceptionIndicator />
            {{else if item.hasOverride}}
              <OverrideIndicator @variant={{item.overrideVariant}} />
            {{/if}}
          </button>
        </li>
      {{/each}}
    </ul>
  </nav>
</template> satisfies TOC<DayOverrideModalSidebarSignature>;

export default DayOverrideModalSidebar;
